export const TEAM_CREST_TEST_IDS = {
  kit: 'team-crest-kit',
  logo: 'team-crest-logo',
  monogram: 'team-crest-monogram',
} as const;

/** Longest monogram we render; three initials still fit a 40px circle. */
const MAX_MONOGRAM_LENGTH = 3;

/**
 * Initials fallback for a team with no logo.
 *
 * Multi-word names use each word's first letter ("Boston Bruisers" → "BB"); a single word uses
 * its first two letters ("Thunder" → "TH"), which reads better than one lonely character.
 */
export function buildMonogram(teamName: string): string {
  const words = (teamName ?? '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';

  if (words.length === 1) {
    return words[0].slice(0, 2).toUpperCase();
  }

  return words
    .slice(0, MAX_MONOGRAM_LENGTH)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}
